// 市场拓展目标详情详情
<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">详情</div>
      </div>
      <template v-if="guid">
        <!-- 基础信息start -->
        <div class="basic-infor">
          <div class="import-title">
            <span class="sub-title">基础信息</span>
          </div>
          <div class="customer-information">
            <div class="cols">
              <div class="col-itms">
                <div class="title">公司名称：</div>
                <div class="content-info w200">{{ form.tenantName }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">选择部门：</div>
                <div class="content-info w300">{{ form.organisationName || '-' }}</div>
              </div>
            </div>

            <div class="cols">
              <div class="col-itms">
                <div class="title">目标产品：</div>
                <div class="content-info w200">{{ form.goodsName }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">产品规格：</div>
                <div class="content-info w200">{{ form.goodsSpec }}</div>
              </div>
            </div>

            <div class="cols">
              <div class="col-itms">
                <div class="title">生产厂家：</div>
                <div class="content-info w200">{{ form.producer }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">年份：</div>
                <div class="content-info w200">{{ form.year }}</div>
              </div>
            </div>
            
          </div>
          
        </div>
        <!-- 基础信息end -->
        
        <!-- 拓展目标start -->
        <div class="second">
          <template>
            <div class="customer-information">
              <div class="sub-title">拓展目标</div>
              <div class="customer-information">
              <div class="cols">
                <div class="col-itms">
                  <div class="title">1月拓展目标金额（元）：</div>
                  <div class="content-info w200">{{ (form.janExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">2月拓展目标金额（元）：</div>
                  <div class="content-info w300">{{ (form.febExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">3月拓展目标金额（元）：</div>
                  <div class="content-info w200">{{ (form.marExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">4月拓展目标金额（元）：</div>
                  <div class="content-info w300">{{ (form.aprExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">5月拓展目标金额（元）：</div>
                  <div class="content-info w200">{{ (form.mayExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">6月拓展目标金额（元）：</div>
                  <div class="content-info w300">{{ (form.junExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">7月拓展目标金额（元）：</div>
                  <div class="content-info w200">{{ (form.julExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">8月拓展目标金额（元）：</div>
                  <div class="content-info w300">{{ (form.augExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">9月拓展目标金额（元）：</div>
                  <div class="content-info w200">{{ (form.septExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">10月拓展目标金额（元）：</div>
                  <div class="content-info w300">{{ (form.octExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">11月拓展目标金额（元）：</div>
                  <div class="content-info w200">{{ (form.novExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">12月拓展目标金额（元）：</div>
                  <div class="content-info w300">{{ (form.decExpandTarget||'-') | numFmt | numDigit }}</div>
                </div>
              </div>
              <div class="cols">
                <div class="col-itms">
                  <div class="title">年底拓展目标金额合计（元）：</div>
                  <div class="content-info w200">{{ (form.expandTargetTotal||'-') | numFmt | numDigit }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">合计大写：</div>
                  <div class="content-info w300">{{ form.expandTargetTotal |smallToBig}}</div>
                </div>
              </div>

              
            </div>
              
            </div>
          </template>
          <!-- 其他信息end -->
        </div>
       
        
      </template>
      
    
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fullscreenLoading:false,
      guid:'',
      form:{
        guid:'',// 系统唯一标识
        tenantGuid:'',//企业GUID
        tenantName:'',//企业名称
        organisationGuid:'',//组织GUID
        goodsGuid:'',//商品GUID，关联mf_goods的guid
        goodsName:'',//商品名称
        goodsSpec:'',//商品规格
        producer:'',//生产厂商
        year	:'',//年份
        janExpandTarget:'',//一月拓展目标金额
        febExpandTarget	:'',//二月拓展目标金额
        marExpandTarget	:'',//三月拓展目标金额
        aprExpandTarget	:'',//四月拓展目标金额
        mayExpandTarget	:'',//五月拓展目标金额
        junExpandTarget	:'',//六月拓展目标金额
        julExpandTarget	:'',//七月拓展目标金额
        augExpandTarget:'',//八月拓展目标金额
        septExpandTarget:'',//九月拓展目标金额
        octExpandTarget	:'',//十月拓展目标金额
        novExpandTarget:'',//十一月拓展目标金额
        decExpandTarget	:'',//十二月拓展目标金额
        expandTargetTotal	:'',//总计
      },
      
    };
  },
  watch: {},
  computed: {},
  created() {
    this.guid=this.$route.query.guid
    this.getDataDetail();
    // this.getNameByguid()
  },
  methods: {
    back() {
      let self = this;
      self.$router.push({ path: '/marketingTargetList' });
    },
    
    // 获取详情
    getDataDetail() {
        let that = this;
        that.fullscreenLoading=true
        that.api
          .get(
            `/${serverConfig.msSalesPerformService}/marketExpandTarget/detail/${that.guid}`
          )
          .then((res) => {
            that.fullscreenLoading=false
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              that.form = res.data.data;
              
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
        
   
  },
};
</script>

<style scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}
.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.customer-information .sub-title {
  text-align: left;
  font-size: 16px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

/* .customer-information .col-itms .title1 {
  width: 120px;
  text-align: right;
  line-height: 30px;
} */
.customer-information .col-itms .title {
  width: 200px;
  text-align: right;
  line-height: 30px;
  /* margin-right: 16px; */
}

/* .customer-information .col-itms.second {
  margin-left: 170px;
} */

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.operte-btns .btn.reject {
  border: 1px solid #f56c6c;
  background-color: #ffffff;
  color: red;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.bank-info {
  color: #a7a7a7;
}
/* 新增样式 */
.w200 {
  width: 200px;
}
.w300 {
  width: 200px;
}
.sub-title {
  color: #212121;
  font-size: 16px;
}
.title {
  color: #666666;
}
.title-col {
  color: #666666;
  text-align: left;
  height: 32px;
  line-height: 32px;
}
.content-info {
  text-align: left;
  color: #212121;
}
.other-info {
  width: 320px;
  padding-left: 70px;
}
.other-info-second {
  margin-left: 170px;
}
.content-box {
  line-height: 32px;
  width: 400px;
  min-height: 32px;
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  padding-left: 10px;
}
.content-info-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex-position {
  align-items: start !important;
}
/deep/.el-dialog__footer {
  border-top: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.basic-infor {
  position: relative;
}
.approve-img {
  position: absolute;
  top: 5px;
  right: 60px;
  width: 78px;
  height: 78px;
}
.no-data {
  padding-top: 100px;
  height: 100%;
}
</style>
